'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var HairDryer = function (_React$Component) {
    _inherits(HairDryer, _React$Component);

    function HairDryer() {
        _classCallCheck(this, HairDryer);

        return _possibleConstructorReturn(this, (HairDryer.__proto__ || Object.getPrototypeOf(HairDryer)).apply(this, arguments));
    }

    _createClass(HairDryer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M25.324 5.647c-0.17-0.135-0.39-0.185-0.6-0.135l-3.947 0.936c-1.966-0.17-9.040-1.841-10.456-2.471-1.241-0.555-2.606-0.745-3.972-0.55-3.197 0.45-5.768 3.107-6.123 6.318-0.225 2.051 0.425 4.102 1.791 5.628 0.835 0.93 1.886 1.616 3.047 2.011-0.040 3.117 0.475 6.303 1.481 9.035 0.52 1.406 1.871 2.351 3.362 2.351 3.132 0 3.677-3.022 3.542-4.042-0.355-2.671-0.735-5.948-0.981-8.194 2.827-0.77 6.974-1.736 8.309-1.856l3.947 0.935c0.26 0.035 0.475-0.035 0.6-0.135 0.17-0.135 0.27-0.34 0.27-0.555v-8.72c0-0.215-0.1-0.42-0.27-0.555zM9.905 27.354c-0.905 0-1.721-0.575-2.036-1.426-0.915-2.481-1.401-5.373-1.396-8.214 1.096 0.155 2.701-0.105 3.537-0.43 0.245-0.095 0.62-0.215 1.086-0.355 0.25 2.246 0.615 5.398 0.961 7.989 0.075 0.61-0.165 2.436-2.151 2.436zM20.121 13.331c-6.444 1.246-10.246 2.496-10.631 2.631-3.162 1.086-5.323-0.31-6.423-1.536-1.116-1.246-1.626-2.852-1.441-4.527 0.285-2.576 2.361-4.673 4.918-5.078 1.356-0.215 2.456 0.11 3.197 0.44 1.416 0.63 7.769 2.156 10.381 2.526v5.543zM24.183 14.026l-2.646-0.625v-5.683l2.646-0.625v6.934z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M3.257 10.56c0 2.161 1.756 3.917 3.917 3.917s3.917-1.756 3.917-3.917c0-2.161-1.756-3.917-3.917-3.917s-3.917 1.761-3.917 3.917zM9.68 10.56c0 1.381-1.126 2.506-2.506 2.506s-2.506-1.126-2.506-2.506 1.126-2.506 2.506-2.506 2.506 1.126 2.506 2.506z' })
            );
        }
    }]);

    return HairDryer;
}(_react2.default.Component);

HairDryer.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = HairDryer;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/hair-dryer.js
// module id = 1104
// module chunks = 0